import type { TContent } from '~/types/common';

export const checkQuiz = (item: TContent): boolean => {
  const { type, children } = item;
  const urlRegExp = /quiz-stage|quiz/gm;

  if (!type.startsWith('bh-kiss__html')) {
    return false;
  }

  if (children.length !== 2) {
    return false;
  }

  if (children.length === 2) {
    for (const item of children) {
      if (
        item.attributes?.src?.match(urlRegExp) ||
        item.children.some((elem) => elem.attributes.src.match(urlRegExp))
      ) {
        return true;
      }
    }
  }

  return false;
};
